/**
 * Hardcoded from the project-level Standard Format.csv (CIQ-13358).
 * Panel copy only — template download comes from the BE endpoint.
 */
export const SCOPE_ITEMS_IMPORT_INSTRUCTIONS = [
  "Title is mandatory and must be unique. Blank titles will be skipped. If duplicate titles exist, only the first occurrence will be imported",
  "Scope items are matched and updated by Title.",
  "Enter only codes for UniFormat and MasterFormat."
] as const;

export const SCOPE_ITEMS_IMPORT_TEMPLATE_FILENAME =
  "Design_Scope_Standard_Format.csv";
